import { stringIsNullOrEmpty } from './string.util';
import { FACTORY_RESOURCE_PROVIDER, FACTORY_RESOURCE_TYPE, WORKSPACE_RESOURCE_PROVIDER, WORKSPACE_RESOURCE_TYPE } from 'app/services/globals';
import _ from 'lodash';

export class ResourceId {
    private _subscriptionId: string;
    private _resourceGroupName: string;
    private _resourceName: string;
    private _resourceType: string;
    private _resourceId: string;

    /**
     * Type is found after the resource type.
     */
    private _nestedType: string;

    /**
     * Name of the nested resource.
     */
    private _nestedResourceName: string;

    private _topResourceName: string;
    private _subResourceType: string;
    private _subResourceName: string;
    /**
     * Gets a ResourceId object from a string resource id.
     * @param resourceIdString
     * /subscriptions/{subscriptionId}/resourcegroups/{resourceGroupName}/providers/{Param.providerName}/{Param.topResourceType}/{topResourceName}
     * /subscriptions/{subscriptionId}/resourcegroups/{resourceGroupName}/providers/{Param.providerName}/{Param.topResourceType}/{topResourceName}/{resourceType}/{resourceName}
     */
    public static parseFrom(resourceIdString: string, providerName?: string, topResourceType?: string): ResourceId | null {
        // Sanitize the resourceIdString
        const sanitizedResourceIdString = _.escape(resourceIdString);

        const resourceId = new ResourceId();
        resourceId._resourceId = sanitizedResourceIdString;
        const splits = sanitizedResourceIdString.split('/');

        if (stringIsNullOrEmpty(providerName)) {
            providerName = __IS_A365__ ? WORKSPACE_RESOURCE_PROVIDER : FACTORY_RESOURCE_PROVIDER;
        }
        if (stringIsNullOrEmpty(topResourceType)) {
            topResourceType = __IS_A365__ ? WORKSPACE_RESOURCE_TYPE : FACTORY_RESOURCE_TYPE;
        }

        if (splits.length >= 9
            && splits[1].toLowerCase() === 'subscriptions'
            && splits[3].toLowerCase() === 'resourcegroups'
            && splits[5].toLowerCase() === 'providers'
            && splits[6].toLowerCase() === providerName.toLowerCase()
            && splits[7].toLowerCase() === topResourceType.toLowerCase()) {
            resourceId._subscriptionId = splits[2];
            resourceId._resourceGroupName = splits[4];
            resourceId._topResourceName = splits[8];
            if (splits.length > 9) {
                resourceId._resourceType = splits[9];
                resourceId._resourceName = splits[10];
                resourceId._subResourceType = splits[9];
                resourceId._subResourceName = splits[10];
                resourceId._nestedType = splits[11];
                resourceId._nestedResourceName = splits[12];
            } else {
                resourceId._resourceName = splits[8];
            }
        } else if (splits.length === 2) {
            resourceId._resourceType = splits[0];
            resourceId._resourceName = splits[1];
        } else {
            return null;
        }

        return resourceId;
    }

    public set resourceName(val: string) {
        this._resourceName = val;
    }

    public get resourceName(): string {
        return this._resourceName;
    }

    public get resourceType(): string {
        return this._resourceType;
    }

    public get resourceId(): string {
        return this._resourceId;
    }

    public get resourceGroupName(): string {
        return this._resourceGroupName;
    }

    public get subscriptionId(): string {
        return this._subscriptionId;
    }

    public get topResourceName(): string {
        return this._topResourceName;
    }

    public get subResourceType(): string {
        return this._subResourceType;
    }

    public get subResourceName(): string {
        return this._subResourceName;
    }

    public get nestedType(): string {
        return this._nestedType;
    }

    public get nestedResouceName(): string {
        return this._nestedResourceName;
    }
}
